module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-anchor-links/gatsby-browser.js'),
      options: {"plugins":[],"offset":-100},
    },{
      plugin: require('../node_modules/gatsby-plugin-sentry/gatsby-browser.js'),
      options: {"plugins":[],"dsn":"https://cd6dc69e3c3641a39175fe1b6d6200fb@sentry.io/1877838","environment":"production","enabled":"true"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
